var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled, { css } from 'styled-components';
import { ButtonStyles, Size } from '../Button/button';
var LinkStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
export var Link = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), LinkStyles);
Link.defaultProps = {
    disabled: false,
};
export var Button = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  display: inline-block;\n"], ["\n  ", "\n  display: inline-block;\n"])), ButtonStyles);
Button.defaultProps = {
    disabled: false,
    size: Size.medium,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=link.js.map